// components/ShadowingSection.jsx
import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import styles from "../Info.module.css";

const ShadowingSection = () => {
  return (
    <section className={styles.section}>
      <div className={styles.sectionInner}>
        <Reveal>
          <SectionHeading
            badge="ویژه ⭐"
            badgeColor="gold"
            title="تکنیک سایه (Shadowing)"
            subtitle="همزمان با بازیگرها تکرار کن، تلفظ و لحنت رو تقویت کن."
          />
        </Reveal>

        <Reveal delay={100}>
          <div className={styles.shadowBox}>
            <div className={styles.waveIcon}>
              <i className="fas fa-microphone-lines"></i>
              <div className={styles.waveBars}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
            <div className={styles.shadowText}>
              <h3>مثل سایه، هم‌گام با بازیگر</h3>
              <p>
                هر بخشی از فیلم رو که خواستی، تمرین کن — جمله رو بایست و با لحن و
                تلفظ بازیگر تکرار کن. تکنیک سایه تلفظ و fluency رو درگیر
                می‌کنه، نه فقط دایره واژگان.
              </p>
              <div className={styles.inlineCta}>
                <Link to="/Subscription" className={styles.ctaInlineBtn}>
                  تمرین سایه رو شروع کن
                  <i className="fas fa-arrow-left"></i>
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ShadowingSection;